module.exports = __webpack_public_path__ + "img/banner4.137b05e0.jpg";